"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.v2Input = exports.primaryInput = exports.inputTransition = exports.baseInput = exports.clearButtonStyle = exports.lightButtonStyle = exports.outlineDarkButtonStyle = exports.darkButtonStyle = exports.outlinePrimaryButtonStyle = exports.primaryButtonStyle = void 0;
var colors_1 = require("./colors");
var color_1 = __importDefault(require("color"));
var isiOS_1 = require("../utils/isiOS");
var baseButtonStyle = {
    display: 'flex',
    width: 'fit-content',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'normal',
    letterSpacing: '0.8px',
    borderStyle: 'solid',
    borderWidth: '1px',
    padding: '16px 30px',
    cursor: 'pointer',
    textAlign: 'center',
    // transition
    transitionProperty: 'color, backgroundColor, background',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'ease',
    ":disabled": {
        cursor: 'not-allowed',
        backgroundColor: colors_1.colors.lightBackground,
        borderColor: colors_1.colors.lightGray,
        color: colors_1.colors.disabledLightGrey,
        ':hover': {
            backgroundColor: colors_1.colors.lightBackground,
            borderColor: colors_1.colors.lightGray,
            color: colors_1.colors.disabledLightGrey
        },
    },
};
exports.primaryButtonStyle = __assign(__assign({}, baseButtonStyle), { 
    // colors
    backgroundColor: colors_1.colors.primary, borderColor: colors_1.colors.primary, color: colors_1.colors.contrastText, ':hover': (0, isiOS_1.isMobile)() ? undefined : {
        backgroundColor: colors_1.colors.contrastText,
        color: colors_1.colors.primary,
        borderColor: colors_1.colors.primary
    }, ":active": {
        backgroundColor: colors_1.colors.contrastText,
        color: (0, color_1.default)(colors_1.colors.primary).darken(0.2).toString(),
        borderColor: (0, color_1.default)(colors_1.colors.primary).darken(0.2).toString()
    } });
exports.outlinePrimaryButtonStyle = __assign(__assign({}, baseButtonStyle), { 
    // colors
    backgroundColor: colors_1.colors.contrastText, borderColor: colors_1.colors.primary, color: colors_1.colors.primary, ':hover': (0, isiOS_1.isMobile)() ? undefined : {
        backgroundColor: colors_1.colors.primary,
        color: colors_1.colors.contrastText,
        borderColor: colors_1.colors.white
    }, ":active": {
        backgroundColor: colors_1.colors.primary,
        color: (0, color_1.default)(colors_1.colors.contrastText).darken(0.2).toString(),
        borderColor: (0, color_1.default)(colors_1.colors.primary).darken(0.2).toString()
    } });
exports.darkButtonStyle = __assign(__assign({}, baseButtonStyle), { 
    /* Reset for V2 styles */
    // Replace padding with center-aligned flexbox and fixed default height
    padding: '10px 16px', height: '40px', 
    // Change text styles
    // TODO: Migrate from Label instead of overriding
    '& > div': {
        textTransform: 'none',
        fontWeight: '400',
    }, 
    // colors
    backgroundColor: colors_1.colors.black, borderColor: colors_1.colors.black, color: colors_1.colors.contrastText, ":disabled": {
        cursor: 'not-allowed',
        backgroundColor: colors_1.colors.disabledBackground,
        borderColor: colors_1.colors.lightGray,
        color: colors_1.colors.disabledLightGrey,
        ':hover': {
            backgroundColor: colors_1.colors.disabledBackground,
            borderColor: colors_1.colors.lightGray,
            color: colors_1.colors.disabledLightGrey
        },
    }, ':hover': (0, isiOS_1.isMobile)() ? undefined : {
        backgroundColor: colors_1.colors.white,
        color: colors_1.colors.text,
        borderColor: colors_1.colors.black
    }, ":active": {
        backgroundColor: colors_1.colors.white,
        color: colors_1.colors.text,
        borderColor: colors_1.colors.black
    } });
exports.outlineDarkButtonStyle = __assign(__assign({}, baseButtonStyle), { 
    /* Reset for V2 styles */
    // Replace padding with center-aligned flexbox and fixed default height
    padding: '10px 16px', height: '40px', 
    // Change text styles
    // TODO: Migrate from Label instead of overriding
    '& > div': {
        textTransform: 'none',
        fontWeight: '400',
    }, 
    // colors
    backgroundColor: colors_1.colors.white, borderColor: colors_1.colors.black, color: colors_1.colors.black, ":disabled": {
        cursor: 'not-allowed',
        backgroundColor: colors_1.colors.disabledBackground,
        borderColor: colors_1.colors.lightGray,
        color: colors_1.colors.disabledLightGrey,
        ':hover': {
            backgroundColor: colors_1.colors.disabledBackground,
            borderColor: colors_1.colors.lightGray,
            color: colors_1.colors.disabledLightGrey
        },
    }, ':hover': (0, isiOS_1.isMobile)() ? undefined : {
        backgroundColor: colors_1.colors.black,
        color: colors_1.colors.contrastText,
        borderColor: colors_1.colors.contrastText
    }, ":active": {
        backgroundColor: colors_1.colors.black,
        color: colors_1.colors.contrastText,
        borderColor: colors_1.colors.contrastText
    } });
exports.lightButtonStyle = __assign(__assign({}, baseButtonStyle), { 
    // colors
    backgroundColor: colors_1.colors.darkModeCoolGrey, borderColor: colors_1.colors.darkModeCoolGrey, color: colors_1.colors.text, ":disabled": {
        cursor: 'not-allowed',
        backgroundColor: colors_1.colors.disabledBackground,
        borderColor: colors_1.colors.lightGray,
        color: colors_1.colors.disabledLightGrey,
        ':hover': {
            backgroundColor: colors_1.colors.disabledBackground,
            borderColor: colors_1.colors.lightGray,
            color: colors_1.colors.disabledLightGrey
        },
    }, ':hover': (0, isiOS_1.isMobile)() ? undefined : {
        backgroundColor: colors_1.colors.white,
        color: colors_1.colors.text,
        borderColor: colors_1.colors.darkModeCoolGrey,
    }, ":active": {
        backgroundColor: colors_1.colors.white,
        color: colors_1.colors.text,
        borderColor: (0, color_1.default)(colors_1.colors.darkModeCoolGrey).darken(0.2).toString()
    } });
exports.clearButtonStyle = __assign(__assign({}, baseButtonStyle), { borderRadius: '4px', 
    // colors
    backgroundColor: 'rgba(255, 255, 255, 0)', borderColor: 'rgba(255, 255, 255, 0.65)', color: colors_1.colors.white, ":disabled": {
        cursor: 'not-allowed',
        backgroundColor: 'transparent',
        borderColor: colors_1.colors.disabledLightGrey,
        color: colors_1.colors.disabledLightGrey,
        ':hover': {
            backgroundColor: 'transparent',
            borderColor: colors_1.colors.disabledLightGrey,
            color: colors_1.colors.disabledLightGrey
        },
    }, ':hover': (0, isiOS_1.isMobile)() ? undefined : {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(4px)',
    }, ":active": {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(4px)',
    } });
exports.baseInput = {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    // reset border radius ,safari has default border radius for select
    borderRadius: '0px',
    padding: '14px 0px',
    width: '100%',
    fontSize: '16px',
    fontFamily: 'Roboto,"Helvetica Neue",Helvetica,"Segoe UI",Arial,freesans,sans-serif',
    lineHeight: 'initial',
    '&:disabled': {
        cursor: 'not-allowed'
    }
};
exports.inputTransition = {
    transitionDuration: '0.2s',
    transitionProperty: 'border-color',
    color: colors_1.colors.text,
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: colors_1.colors.lightGray,
    ':focus': {
        borderBottomColor: colors_1.colors.primary
    },
    ':hover': {
        borderBottomColor: colors_1.colors.primary
    }
};
exports.primaryInput = __assign(__assign({}, exports.baseInput), exports.inputTransition); // needs to override or inputTransition will complain
exports.v2Input = {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    color: 'rgba(23, 26, 32, 1)',
    backgroundColor: '#F4F4F4',
    outline: 'none',
    border: '1px solid transparent',
    ':focus': {
        border: '1px solid #D0D1D2'
    },
    ':hover': {
        border: '1px solid #D0D1D2'
    },
    ':active': {
        border: '1px solid #D0D1D2'
    },
    ':disabled': {
        cursor: 'not-allowed',
        border: '1px solid transparent',
    },
    '&.error': {
        border: "1px solid " + colors_1.colors.error2,
        ':focus': {
            border: '1px solid #D0D1D2'
        },
        ':hover': {
            border: '1px solid #D0D1D2'
        },
        ':active': {
            border: '1px solid #D0D1D2'
        },
    }
};
